(function () {
  if (window.stateChampsSignupReady) return;
  window.stateChampsSignupReady = true;
  var phoneLibraryPromise;
  var successKey = 'stateChampsSignupSuccess';
  var successThisSession = false;

  try { successThisSession = sessionStorage.getItem(successKey) === 'true'; } catch (error) { /* Storage can be unavailable. */ }

  function loadPhoneLibrary(url) {
    if (window.intlTelInput) return Promise.resolve(window.intlTelInput);
    if (!phoneLibraryPromise) {
      phoneLibraryPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = function () { window.intlTelInput ? resolve(window.intlTelInput) : reject(new Error('Phone picker unavailable.')); };
        script.onerror = function () { reject(new Error('Phone picker unavailable.')); };
        document.head.appendChild(script);
      });
    }
    return phoneLibraryPromise;
  }

  function hideTeasers() {
    document.querySelectorAll('[data-sc-signup-teaser]').forEach(function (teaser) { teaser.hidden = true; });
  }

  function markSuccess() {
    successThisSession = true;
    try { sessionStorage.setItem(successKey, 'true'); } catch (error) { /* Current page still remembers success. */ }
    hideTeasers();
  }

  function formatBirthday(value) {
    if (!value) return '';
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;
    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var date = new Date(Date.UTC(year, month - 1, day));
    if (year < 1900 || date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day || value > new Date().toISOString().slice(0, 10)) return null;
    return match[2] + '/' + match[3] + '/' + match[1];
  }

  function initTeaser(teaser) {
    if (teaser.dataset.initialized) return;
    teaser.dataset.initialized = 'true';
    var popup = document.getElementById(teaser.dataset.popupId);
    if (!popup) return;
    var eventName = teaser.dataset.popupId;
    teaser.hidden = successThisSession || popup.classList.contains('modal--is-active');
    document.addEventListener('modalOpen.' + eventName, function () {
      hideTeasers();
      if (successThisSession) popup.querySelector('.js-modal-close').click();
    });
    document.addEventListener('modalClose.' + eventName, function () {
      teaser.hidden = successThisSession;
    });
  }

  function init(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    var phone = form.elements.phone;
    var birthday = form.elements.birthday;
    var consent = form.elements.sms_consent;
    var consentWrap = form.querySelector('[data-sms-consent]');
    var status = form.querySelector('[data-status]');
    var button = form.querySelector('[type="submit"]');
    var popup = form.dataset.source === 'popup' ? form.closest('.modal') : null;
    var formContent = popup && popup.querySelector('[data-signup-popup-content]');
    var success = popup && popup.querySelector('[data-signup-success]');
    function showNormalContent() {
      if (!formContent || !success) return;
      success.hidden = true;
      success.style.display = 'none';
      formContent.hidden = false;
      formContent.style.display = '';
      success.style.minHeight = '';
    }
    showNormalContent();
    var phonePicker;
    var phoneReady = false;

    function updatePhone() {
      var hasPhone = phone.value.trim().length > 0;
      consentWrap.dataset.open = hasPhone ? 'true' : 'false';
      consentWrap.setAttribute('aria-hidden', hasPhone ? 'false' : 'true');
      consentWrap.inert = !hasPhone;
      consent.disabled = !hasPhone;
      consent.required = hasPhone;
      if (!hasPhone) consent.checked = false;
    }

    function updateBirthday() {
      birthday.dataset.empty = birthday.value ? 'false' : 'true';
    }

    function resetForm() {
      try {
        form.reset();
        updateBirthday();
        if (phonePicker) { phonePicker.setNumber(''); phonePicker.setSelectedCountry('us'); }
        updatePhone();
      } catch (error) { /* A phone picker reset cannot undo a completed signup. */ }
    }

    phone.addEventListener('input', updatePhone);
    birthday.addEventListener('input', updateBirthday);
    birthday.addEventListener('change', updateBirthday);
    birthday.max = new Date().toISOString().slice(0, 10);
    updateBirthday();
    updatePhone();
    button.disabled = false;

    loadPhoneLibrary(form.dataset.intlScript).then(function (intlTelInput) {
      if (!form.isConnected) return;
      phonePicker = intlTelInput(phone, {
        initialCountry: 'us',
        separateDialCode: false,
        numberDisplayFormat: 'NATIONAL',
        placeholderNumberPolicy: 'OFF',
        dropdownParent: form.closest('.modal') || undefined,
        loadUtils: function () { return import(form.dataset.intlUtils); }
      });
      return phonePicker.promise.then(function () { phoneReady = true; });
    }).catch(function () { phoneReady = false; });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (success && !success.hidden) return;
      updatePhone();
      status.textContent = '';
      status.dataset.state = '';

      var email = form.elements.email.value.trim();
      var phoneValue = phone.value.trim();
      birthday.max = new Date().toISOString().slice(0, 10);
      if (!email && !phoneValue) {
        status.textContent = 'Enter an email address or phone number.';
        status.dataset.state = 'error';
        form.elements.email.focus();
        return;
      }
      if (!form.reportValidity()) return;
      var formattedBirthday = formatBirthday(birthday.value);
      if (formattedBirthday === null) {
        status.textContent = 'Select a valid birthday that is not in the future.';
        status.dataset.state = 'error';
        birthday.focus();
        return;
      }
      if (phoneValue && (!phoneReady || !phonePicker)) {
        status.textContent = 'Phone field is still loading. Please try again.';
        status.dataset.state = 'error';
        phone.focus();
        return;
      }
      if (phoneValue && !phonePicker.isValidNumber()) {
        status.textContent = 'Enter a valid phone number for the selected country.';
        status.dataset.state = 'error';
        phone.focus();
        return;
      }
      var normalizedPhone = phoneValue ? phonePicker.getNumber() : '';

      button.disabled = true;
      status.textContent = 'Submitting…';
      var providerError = '';
      try {
        var response = await fetch(form.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            first_name: form.elements.first_name.value.trim(),
            last_name: form.elements.last_name.value.trim(),
            email: email,
            phone: normalizedPhone,
            country_code: 'international',
            birthday: formattedBirthday,
            zip: form.elements.zip.value.trim(),
            sms_consent: consent.checked,
            company: form.elements.sc_verify_field.value,
            source: form.dataset.source
          })
        });
        var result = await response.json();
        if (!result || typeof result !== 'object' || Array.isArray(result)) throw new Error('Invalid signup response');
        if (!response.ok && !result.email && !result.sms) {
          providerError = result.message || 'Signup could not be completed. Please try again.';
          throw new Error('Provider request failed');
        }
        if ((email && typeof result.email !== 'boolean') || (phoneValue && typeof result.sms !== 'boolean')) {
          throw new Error('Missing or invalid signup results');
        }

        var outcomes = [];
        if (email) outcomes.push(result.email ? 'Email signup received.' : 'Email signup failed.');
        if (phoneValue) outcomes.push(result.sms ? 'Text signup received.' : 'Text signup failed.');
        if (result.details === false) outcomes.push('Your profile details could not be saved.');
        var complete = result.details !== false && (!email || result.email) && (!phoneValue || result.sms);
        status.textContent = outcomes.join(' ');
        status.dataset.state = complete ? 'success' : 'error';
        if (complete) {
          markSuccess();
          if (form.dataset.source === 'popup') {
            if (formContent && success) {
              success.querySelector('[data-signup-success-copy]').textContent = email ? 'CHECK YOUR INBOX FOR YOUR 15% OFF CODE.' : 'THANKS FOR SIGNING UP.';
              success.style.minHeight = formContent.getBoundingClientRect().height + 'px';
              formContent.hidden = true;
              formContent.style.display = 'none';
              success.hidden = false;
              success.style.display = 'flex';
              success.focus({ preventScroll: true });
            }
            window.setTimeout(function () {
              var popup = form.closest('.modal');
              if (status.dataset.state === 'success' && popup && popup.classList.contains('modal--is-active')) popup.querySelector('.js-modal-close').click();
              resetForm();
              showNormalContent();
            }, 4000);
          } else {
            resetForm();
          }
        }
      } catch (error) {
        status.textContent = providerError || 'Signup could not be completed. Please try again.';
        status.dataset.state = 'error';
      } finally {
        button.disabled = false;
      }
    });
  }

  document.querySelectorAll('[data-sc-signup]').forEach(init);
  document.querySelectorAll('[data-sc-signup-teaser]').forEach(initTeaser);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-sc-signup]').forEach(init);
    event.target.querySelectorAll('[data-sc-signup-teaser]').forEach(initTeaser);
  });
})();
